import * as React from "react";
import { connect } from "react-redux";
import { Typography, LinkText } from "../../ecosystem";

const LogInFooterHelpDesk = ({
    technicalHelpDeskHours,
    technicalHelpDeskNumber,
    isMobile
}) => {

    const textColor = isMobile ? "$color-secondary-a1" : "";

    return <div className="login-footer-help-desk text-center">
        <Typography type="body-01" color={textColor}>
            Call the MyBSWHealth technical help desk at 
        </Typography> <LinkText
            typographyType="body-01"
            to={{ pathname: 'tel:' + technicalHelpDeskNumber }}
            underline="always"
            decorator="mobile"
        >
            {technicalHelpDeskNumber}
        </LinkText> <Typography type="body-01" color={textColor} tag="div">
            {technicalHelpDeskHours}.
        </Typography>
    </div>;

};

const mapStateToProps = state => {
    return {
        technicalHelpDeskHours: state.session.serverData
            ? state.session.serverData.technicalHelpDeskHours
            : '',
        technicalHelpDeskNumber: state.session.serverData
            ? state.session.serverData.technicalHelpDeskNumber
            : '',
    }
};

export default connect(mapStateToProps)(LogInFooterHelpDesk);